export default class Kt {
  constructor(
    t = 0,
    i = [],
    s = [],
    h = [],
    e = null,
    l = null,
    r = { enabled: !1 },
    a = { enabled: !1, refresh_rate_limit: void 0 },
  ) {
    (this.ol = t),
      (this.cl = i),
      (this.gl = s),
      (this.fl = h),
      (this.bl = e),
      (this.al = l),
      (this.ml = r),
      (this.gi = a),
      (this.ol = t),
      (this.cl = i),
      (this.gl = s),
      (this.fl = h),
      (this.bl = e),
      (this.al = l),
      (this.ml = r),
      (this.gi = a);
  }
  tt() {
    return {
      s: "5.0.1",
      l: this.ol,
      e: this.cl,
      a: this.gl,
      p: this.fl,
      m: this.bl,
      v: this.al,
      c: this.ml,
      f: this.gi,
    };
  }
  static Yn(t) {
    let i = t.l;
    return (
      "5.0.1" !== t.s && (i = 0), new Kt(i, t.e, t.a, t.p, t.m, t.v, t.c, t.f)
    );
  }
}
